export const PAYMENTS_FEATURE_FLAG_KEY = "badgeflow-payments-enabled";

export const isPaymentsFeatureEnabled = () => {
  try {
    const value = localStorage.getItem(PAYMENTS_FEATURE_FLAG_KEY);
    return value === "1" || value === "true" || value === "enabled";
  } catch {
    return false;
  }
};

export const formatUsd = (amountCents) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format((amountCents || 0) / 100);
